var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GridLayout',{staticClass:"color-bar",attrs:{"rows":"auto","columns":"*"}},[_c('StackLayout',{staticClass:"color-bar__badge",attrs:{"row":"0","col":"0","backgroundColor":_vm.color,"width":_vm.width,"height":_vm.height}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }